module.exports = __webpack_public_path__ + "img/tyvm-kasim.88adf343.png";